export enum IFRAME_EVENTS {
    load = 'load',
    message = 'message',
}

export const NC_ORIGIN_URL = 'norcapsecurities.com';
